'use client';

import { BusyContext } from '@/components/common';
import { Typography } from '@andritzot/metris-web-ui/data-display/typography';
import { Box } from '@andritzot/metris-web-ui/layout/content/Box';

import { PlannedHoursSection } from '../CreateItem/PlannedHoursSection';
import { BusinessImpactedSection, TargetBusinessAreasSection } from './BusinessView';

interface BusinessRoadmapTabContentProps {
  isLoading: boolean;
  hasSelectedItem: boolean;
  viewOnly: boolean;
}

export function BusinessRoadmapTabContent({
  isLoading,
  hasSelectedItem,
  viewOnly,
}: Readonly<BusinessRoadmapTabContentProps>) {
  if (isLoading) {
    return <BusyContext isLoading={true} />;
  }

  if (!hasSelectedItem) {
    return (
      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
        Select a roadmap item to view its details.
      </Typography>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', gap: 3, alignItems: 'flex-start' }}>
      <Box sx={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 8 }}>
        <TargetBusinessAreasSection viewOnly={viewOnly} />
        <PlannedHoursSection viewOnly={viewOnly} />
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <BusinessImpactedSection viewOnly={viewOnly} />
      </Box>
    </Box>
  );
}
